import Vue from 'vue'
import VueRouter from 'vue-router'

import utils from '@/utils'

// 首页
const PageHome = resolve => require(['../views/home'], resolve)

// 参赛规则
const PageRule = resolve => require(['../views/rule'], resolve)

// const PageWork = resolve => require(['../views/work'], resolve)

// 往届回顾 - 2021
const PagePast2021 = resolve => require(['../views/past/Past2021'], resolve)
// 往届回顾 - 2020
const PagePast2020 = resolve => require(['../views/past/Past2020'], resolve)
// 往届回顾 - 2019
const PagePast2019 = resolve => require(['../views/past/Past2019'], resolve)

// 入围名单
const PageAwards = resolve => require(['../views/awards/Awards'], resolve)
// 结果公布
const PageResult = resolve => require(['../views/result/Result'], resolve)

// 学习园地 - 区块链
const PageSupportBlockChain = resolve => require(['../views/support/BlockChain'], resolve)
// 学习园地 - 人工智能
const PageSupportAI = resolve => require(['../views/AI'], resolve)

// const PageSupport = resolve => require(['@/views/support/Home.vue'], resolve)
// const PageLoading = resolve => require(['@/views/loading/Loading.vue'], resolve)

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '/',
    name: 'Home',
    component: PageHome,
    meta: { id: 1 }
  },

  // 参赛规则
  {
    path: '/rule',
    name: 'Rule',
    component: PageRule,
    meta: { id: 2 }
  },

  // 往届回顾
  {
    path: '/past/2021',
    name: 'Past2021',
    component: PagePast2021,
    meta: { id: 3 }
  },
  {
    path: '/past/2020',
    name: 'Past2020',
    component: PagePast2020,
    meta: { id: 3 }
  },
  {
    path: '/past/2019',
    name: 'Past2019',
    component: PagePast2019,
    meta: { id: 3 }
  },

  {
    path: '/awards',
    name: 'Awards',
    component: PageAwards,
    meta: { id: 5 }
  },

  {
    path: '/result',
    name: 'Result',
    component: PageResult,
    meta: { id: 6 }
  },

  // 学习园地 - 区块链
  {
    path: '/support/blockchain',
    name: 'SupportBlockchain',
    component: PageSupportBlockChain,
    meta: { id: 4 }
  },

  // 学习园地 - 人工智能
  {
    path: '/support/ai',
    name: 'SupportAI',
    component: PageSupportAI,
    meta: { id: 4 }
  }

  // {
  //   path: '/works',
  //   name: 'Works',
  //   component: PageWork
  // },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BUILD_ENV !== 'test' ? '/zones/fintechathon/campus2022' : '/zones/test/fintechathon/campus2022',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
      // new navigation.
      // scroll to anchor by returning the selector
      if (to.hash) {
        position.selector = to.hash
      }
      // check if any matched route config has meta that requires scrolling to top
      if (to.matched.some(m => m.meta.scrollToTop)) {
        // cords will be used if no selector is provided,
        // or if the selector didn't match any element.
        position.x = 0
        position.y = 0
      }

      if (!Object.keys(position).length) {
        position.x = 0
        position.y = 0
      }

      // if the returned position is falsy or an empty object,
      // will retain current scroll position.
      return position
    }
  }
})

router.afterEach((to, from) => {
  utils.GA('set', 'page', to.fullPath)
  utils.GA('send', 'pageview')
})

export default router
